module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3xwQR"))).then(() => parcelRequire('d0iPb'));